import React, { useState, useEffect } from "react";
import Classes from "../Profile.module.css";
import LanguagesDropDown from "./DropDowns/LanguagesDropDown";
import AvailabilityDropDown from "./DropDowns/AvailabilityDropDown";
import LevelsDropDown from "./DropDowns/LevelsDropDown";

export default function Preferences({ data, update, onNext, onBack }) {
  const [form, setForm] = useState(data);
  useEffect(() => setForm(data), [data]);

  const setArr = (key) => (val) => { setForm((p) => ({ ...p, [key]: val })); update({ [key]: val }); };

  const handleSubmit = (e) => { e.preventDefault(); onNext(); };

  return (
    <form className={Classes.infoCon} onSubmit={handleSubmit}>
      <div className={Classes.infoConMiddle}>
        <div className={Classes.flexColGroup}>
          <div className={Classes.flexCol1}>
            <h5 className={Classes.label}>Preferred Mentor Level</h5>
            <LevelsDropDown selected={form.mentorLevel ?? []} onChange={setArr("mentorLevel")} />
          </div>
        </div>

        <div className={Classes.flexColGroup}>
          <div className={Classes.flexCol1}>
            <h5 className={Classes.label}>Languages Spoken</h5>
            <LanguagesDropDown selected={form.languagesSpoken ?? []} onChange={setArr("languagesSpoken")} />
          </div>
        </div>

        <div className={Classes.flexColGroup}>
          <div className={Classes.flexCol1}>
            <h5 className={Classes.label}>Availability</h5>
            <AvailabilityDropDown selected={form.availability ?? []} onChange={setArr("availability")} />
          </div>
        </div>
      </div>

      <button type="submit" className={Classes.saveBtn}><h5>Next</h5></button>
    </form>
  );
}
